/**
 * @fileoverview AI Evaluation Results Constants
 * @description Score band thresholds, colors, and filter options.
 * @module features/AIEvaluationResults/constants
 */

export const BAND_COLORS = {
  green: '#008653',
  amber: '#D28B00',
  red: '#C81E3A',
  'not-run': '#5B6573',
};

export const BAND_LABELS = {
  green: 'Green — meets target (≥ 0.85)',
  amber: 'Amber — monitor (≥ 0.75)',
  red: 'Red — below target (< 0.75)',
};

export const BAND_STATUS = {
  green: 'Meets target',
  amber: 'Monitor',
  red: 'Below target',
  'not-run': 'Not run',
};

export const BAND_FILTERS = [
  { value: 'all', label: 'All' },
  { value: 'green', label: 'Green' },
  { value: 'amber', label: 'Amber' },
  { value: 'red', label: 'Red' },
];
